export function addChecklistStatusSet({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ showAddChecklistStatusSet: true });
}

